import { useContext } from 'react';

import { BalanceVisibilityContext } from 'src/contexts';

export const useBalanceVisibility = () => useContext(BalanceVisibilityContext);
